import React, { FC } from 'react'
import Tooltip from '../../../../components/common/tooltip/Tooltip'
import { IQuizResponse } from '../../../../../../types/Topic'
import { Trans, t } from '@lingui/macro'

export const QuizTooltip: FC<{
  quizResponse?: IQuizResponse
  children: any
}> = ({ quizResponse, children }) => {
  if (!quizResponse) return <>{children}</>

  const { is_correct, value } = quizResponse

  let titleText
  if (!is_correct && value) {
    titleText = (
      <>
        <Trans>Incorrect answer</Trans>
        <br />(<Trans>correct is unchecked</Trans>)
      </>
    )
  } else if (!is_correct && !value) {
    titleText = (
      <>
        <Trans>Incorrect answer</Trans>
        <br />(<Trans>correct is checked</Trans>)
      </>
    )
  } else {
    titleText = t`Correct answer`
  }

  return (
    <Tooltip position="relative" text={titleText}>
      {children}
    </Tooltip>
  )
}
